import type { SessionUser } from '@viapeople/api/src/modules/users/users.types'
import { Sentry } from '@viapeople/components'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SessionState {
	isLoggedIn: boolean
	user: SessionUser | null
	redirectPath: string | null
	login: (user: SessionUser) => void
	logout: () => void
}

export const sessionStore = create<SessionState>()(
	persist(
		(set) => ({
			isLoggedIn: false,
			user: null,
			redirectPath: null,
			login: (userData: SessionUser) => {
				// Set Sentry user context
				Sentry.setUser({
					id: userData?.id,
					email: userData?.email,
					username: `${userData?.firstName} ${userData?.lastName}`,
				})

				Sentry.setContext('organization', {
					id: userData?.organization?.id,
					name: userData?.organization?.name,
				})

				set({ user: userData, isLoggedIn: true })
			},
			logout: () => {
				// Clear Sentry user context
				Sentry.setUser(null)

				set({ user: null, isLoggedIn: false })
			},
		}),
		{
			name: 'session-storage',
		},
	),
)
